<template>
    <div class="full-modal">
        <div class="btn-exit grow-medium" @click="ExitModal"><i class="pi pi-times"></i></div>
        <h1 class="top-text">Add Notes</h1>
        <div class="tab-bar">
            <button
                class="tab"
                :class="{ active: activeTab === 'notes' }"
                @click="activeTab = 'notes'"
            >General Notes</button>
            <button
                class="tab"
                :class="{ active: activeTab === 'planNotes' }"
                @click="activeTab = 'planNotes'"
            >Plan Notes</button>
        </div>
        <p class="description">{{ activeTab === 'notes' ? 'A place to put down any information not covered in the plan builder' : 'Additional notes to help us implement your plans effectively' }}</p>
        <textarea v-model="currentNote" class="note-box" @input="adjustTextAreaHeight" ref="noteTextArea"></textarea>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    props: {
        planType: String
    },
    data() {
        return {
            activeTab: 'notes'
        };
    },
    mounted() {
        window.addEventListener('keydown', this.handleEscape);
        this.$nextTick(() => {
            this.adjustTextAreaHeight(); // Adjust initially in case of pre-filled content
        });
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.handleEscape);
    },
    watch: {
        activeTab() {
            this.$nextTick(() => this.adjustTextAreaHeight());
        }
    },
    methods: {
        ...mapActions(['setNote', 'setPlanNote']),
        ExitModal() {
            this.$emit('exitModal');
        },
        handleEscape(event) {
            if(event.key === 'Escape') {
                this.ExitModal();
            }
        },
        adjustTextAreaHeight() {
            const textArea = this.$refs.noteTextArea;
            textArea.style.height = "auto"; // Reset height to recalculate
            textArea.style.height = textArea.scrollHeight + "px"; // Set new height based on content
        },
    },
    computed: {
        currentNote: {
            get() {
                return this.activeTab === 'notes'
                    ? this.$store.state.note
                    : this.$store.state.planNote;
            },
            set(val) {
                if (this.activeTab === 'notes') {
                    this.setNote(val);
                } else {
                    this.setPlanNote(val);
                }
            }
        }
    }
}
</script>

<style scoped>

.full-modal {
    position: relative;
    width: 30%;
    height: 55%;
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 20px;
    border: 3px solid var(--color-dark-blue);
    outline: 2px solid white;
    padding: 2%;
}

.btn-exit {
    position: absolute;
    top: 20px;
    right: 25px;
    color: red;
    font-size: 1.75em;
    cursor: pointer;
    font-family: sans-serif
}

.top-text {
    color: var(--font-color-teal);
    margin-top: 0.25em;
}

.tab-bar {
    display: flex;
    gap: 0;
    margin-top: 1em;
    margin-bottom: 1em;
    border-bottom: 2px solid var(--color-medium-light-gray);
    width: 100%;
}

.tab {
    flex: 1;
    padding: 0.5em 1em;
    border: none;
    background: transparent;
    color: var(--color-dark-blue);
    font-family: 'Main';
    font-size: 1em;
    cursor: pointer;
    border-bottom: 3px solid transparent;
    margin-bottom: -2px;
    transition: border-color 0.2s, color 0.2s;
}

.tab:hover {
    color: var(--font-color-teal);
}

.tab.active {
    border-bottom-color: var(--color-bright-blue);
    color: var(--font-color-teal);
    font-weight: 600;
}

.description {
    text-align: center;
    width: 70%;
    margin-top: 0;
}

.note-box {
    margin-top: 2em;
    width: 60%;
    outline: none;
    border: 2px solid var(--color-medium-light-gray);
    border-radius: 10px;
    resize: none;
    padding: 5px;
    font-family: 'Main';
}

.note-box:hover {
    border: 2px solid var(--color-light-blue);
}

.note-box:focus {
    border: 2px solid var(--color-bright-blue);
}
</style>